import { designTokens } from "@itandi/itandi-bb-ui";
import { Flex } from "@itandi/itandi-bb-ui/Flex";
import { Label } from "@itandi/itandi-bb-ui/Label";
import type { ReactNode } from "react";
import { StatusIcon } from "~/components/deprecated/StatusIcon";
import type { CompanyDealTodo } from "~/models/CompanyDealTodo";
import { truncate } from "~/utils/StringUtil";

type Props = {
	originVendorCompany: CompanyDealTodo["originVendorCompany"];
};

export function OriginVendorCompanyCell({
	originVendorCompany
}: Props): ReactNode {
	// 未指定
	if (originVendorCompany === null) {
		return (
			<Flex alignItems="center" gap={designTokens["spacing/xxxs"]}>
				<Label size="s">施工会社未指定</Label>
				<StatusIcon variant="Alert" />
			</Flex>
		);
	}

	return (
		<Flex direction="column" gap={designTokens["spacing/xxxs"]}>
			{truncate(originVendorCompany.name, 35)}
			{originVendorCompany.vendorUser ? (
				<Label color="subtle" size="xs">
					{truncate(originVendorCompany.vendorUser.name, 15)}
				</Label>
			) : (
				<Flex alignItems="center" gap={designTokens["spacing/xxxs"]}>
					<Label size="xs">担当者設定なし</Label>
					<StatusIcon variant="Alert" />
				</Flex>
			)}
		</Flex>
	);
}
